(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-information-group"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wj-product-information-group')) {
  customElements.define('wj-product-information-group', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.animations = new Map();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const options = {signal: this.controller.signal};
      this.addEventListener('click', event => {
        const summary = event.target.closest('summary');
        const details = summary?.parentElement;
        if (event.defaultPrevented || !details?.matches('details.wj-service') || summary.closest('wj-product-information-group') !== this || event.target.closest('a,button,input,select,textarea')) return;
        const body = details.querySelector(':scope > .wj-service__body');
        if (!body?.animate) return;
        event.preventDefault();
        this.toggle(details, summary, body);
      }, options);
      this.addEventListener('toggle', event => {
        if (!event.target.open && this.animations.has(event.target)) this.finish(event.target, false);
      }, {...options, capture: true});
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) [...this.animations.keys()].forEach(details => this.finish(details));
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      [...(this.animations?.keys() || [])].forEach(details => this.finish(details));
      this.controller = null;
    }
    frame(body) {
      const style = getComputedStyle(body);
      return Object.fromEntries(['height', 'marginTop', 'marginBottom', 'paddingTop', 'paddingBottom'].map(key => [key, style[key]]));
    }
    toggle(details, summary, body) {
      const previous = this.animations.get(details);
      const open = previous ? !previous.open : !details.open;
      const collapsed = {height: '0px', marginTop: '0px', marginBottom: '0px', paddingTop: '0px', paddingBottom: '0px'};
      const start = details.open ? this.frame(body) : collapsed;
      if (previous) this.finish(details, details.open);
      if (this.motion.matches) {
        details.open = open;
        return;
      }
      details.open = true;
      const end = open ? this.frame(body) : collapsed;
      const overflow = body.style.overflow;
      body.style.overflow = 'hidden';
      summary.setAttribute('aria-expanded', String(open));
      details.toggleAttribute('data-wj-closing', !open);
      const animation = body.animate([start, end], {duration: 250, easing: 'ease'});
      const state = {animation, open, summary, body, overflow};
      this.animations.set(details, state);
      animation.onfinish = () => {
        if (this.animations.get(details) === state) this.finish(details);
      };
      animation.oncancel = () => {
        if (this.animations.get(details) === state) this.finish(details);
      };
    }
    finish(details, open = this.animations.get(details)?.open) {
      const state = this.animations.get(details);
      if (!state) return;
      this.animations.delete(details);
      details.open = open;
      state.animation.cancel();
      state.body.style.overflow = state.overflow;
      state.summary.removeAttribute('aria-expanded');
      details.removeAttribute('data-wj-closing');
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-measurements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wj-measurements')) {
  customElements.define('wj-measurements', class extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-measurements]').textContent);
      this.labels = Object.fromEntries([...this.querySelectorAll('[data-label]')].map(el => [el.dataset.label, el.textContent]));
      this.changeHandler = event => {
        if (event.target.name !== 'id') return;
        const form = event.target.closest('form');
        if (!form || ![`product-form-${this.dataset.section}`, `sticky-addcart-form-${this.dataset.section}`].includes(form.getAttribute('id'))) return;
        this.update(event.target.value);
      };
      document.addEventListener('change', this.changeHandler);
      const input = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="id"]');
      this.update(input?.value || this.dataset.variant);
    }
    disconnectedCallback() { document.removeEventListener('change', this.changeHandler); }
    update(id) {
      const data = this.variants.find(v => String(v.id) === String(id))?.data;
      const dimensions = data?.dimensions;
      const valid = data?.version === 1 && data?.eligible === true && Array.isArray(dimensions) && dimensions.length > 0 && dimensions.length <= 3 && dimensions.every(x => this.labels[x.key] && x.unit === 'cm' && Number.isFinite(x.min) && Number.isFinite(x.max) && x.min > 0 && x.max >= x.min);
      if (!valid) {
        const details = this.querySelector('details');
        if (!this.hidden && this.contains(document.activeElement)) document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('button[type="submit"]')?.focus({preventScroll:true});
        details.open = false;
        this.hidden = true;
        this.querySelector('dl').replaceChildren();
        return;
      }
      const format = value => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {maximumFractionDigits:4}).format(value);
      const rows = dimensions.map(x => [this.labels[x.key], `${format(x.min)}${x.max === x.min ? '' : `–${format(x.max)}`} cm`]);
      if (Number.isFinite(data.net_weight_kg) && data.net_weight_kg > 0) rows.push([this.labels.net_weight, `${format(data.net_weight_kg)} kg`]);
      const nodes = rows.map(([label, value]) => {
        const row = document.createElement('div'), term = document.createElement('dt'), description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        return row;
      });
      this.querySelector('dl').replaceChildren(...nodes);
      this.dataset.variant = String(id);
      this.hidden = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-safety"] && !Shopify.designMode) return;
  try {
    if (!window.wohnjoyProductInfoRequest) {
  const pending = new Map();
  window.wohnjoyProductInfoRequest = (url, signal) => {
    const key = String(url);
    let entry = pending.get(key);
    if (!entry || entry.controller.signal.aborted) {
      entry = {controller: new AbortController(), consumers: new Set(), finished: false};
      pending.set(key, entry);
      entry.promise = fetch(url, {credentials: 'same-origin', signal: AbortSignal.any([entry.controller.signal, AbortSignal.timeout(12000)])}).then(response => {
        if (!response.ok) throw new Error('Product information unavailable');
        return response.text();
      }).finally(() => {
        entry.finished = true;
        if (pending.get(key) === entry) pending.delete(key);
      });
      entry.promise.catch(() => {});
    }
    return new Promise((resolve, reject) => {
      const consumer = Symbol();
      entry.consumers.add(consumer);
      const release = () => {
        entry.consumers.delete(consumer);
        signal?.removeEventListener('abort', abort);
        if (!entry.consumers.size && !entry.finished) entry.controller.abort();
      };
      const abort = () => {
        release();
        reject(new DOMException('Aborted', 'AbortError'));
      };
      if (signal?.aborted) return abort();
      signal?.addEventListener('abort', abort, {once: true});
      entry.promise.then(value => {release();resolve(value);}, error => {release();reject(error);});
    });
  };
}
if (!customElements.get('wj-product-safety')) {
  customElements.define('wj-product-safety', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.body = this.querySelector('[data-wj-gpsr-body]');
      this.status = this.querySelector('[data-wj-gpsr-status]');
      document.addEventListener('change', event => {
        if (event.target.name !== 'id') return;
        const form = event.target.closest('form');
        if (!form || ![`product-form-${this.dataset.section}`, `sticky-addcart-form-${this.dataset.section}`].includes(form.getAttribute('id'))) return;
        this.load(event.target.value);
      }, {signal: this.events.signal});
      const input = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="id"]');
      if (input?.value && (input.value !== this.dataset.variant || this.needsRefresh)) {
        this.needsRefresh = false;
        this.load(input.value);
      }
    }
    disconnectedCallback() {
      this.needsRefresh = Boolean(this.pending);
      this.events?.abort();
      this.request?.abort();
      this.events = null;
      this.pending = null;
      this.request = null;
    }
    async load(id) {
      id = String(id || '');
      if (!/^\d+$/.test(id) || id === this.pending || id === this.dataset.variant && !this.pending && !this.failed) return;
      const openDocuments = this.body.querySelector('.wj-gpsr__documents')?.open;
      this.request?.abort();
      this.request = new AbortController();
      const request = this.request;
      this.pending = id;
      this.body.style.minHeight = `${this.body.getBoundingClientRect().height}px`;
      this.body.replaceChildren(Object.assign(document.createElement('p'), {textContent: this.dataset.loading}));
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loading;
      try {
        const url = new URL(this.dataset.url, location.origin);
        if (url.origin !== location.origin) throw new Error('Invalid product URL');
        url.searchParams.set('section_id', 'wohnjoy-delivery-data');
        url.searchParams.set('variant', id);
        const html = await window.wohnjoyProductInfoRequest(url, request.signal);
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const data = doc.querySelector('[data-wj-gpsr-response]');
        if (!data || data.dataset.product !== this.dataset.product || data.dataset.variant !== id) throw new Error('Product safety response mismatch');
        if (request !== this.request || !this.isConnected) return;
        this.body.replaceChildren(...[...data.childNodes].map(node => document.importNode(node, true)));
        const documents = this.body.querySelector('.wj-gpsr__documents');
        if (documents && openDocuments) documents.open = true;
        this.dataset.variant = id;
        this.failed = false;
        this.status.textContent = '';
      } catch (error) {
        if (request !== this.request || !this.isConnected) return;
        this.failed = true;
        this.body.replaceChildren(Object.assign(document.createElement('p'), {textContent: this.dataset.error}));
        this.status.textContent = this.dataset.error;
      } finally {
        if (request === this.request) {
          this.pending = null;
          this.body.style.minHeight = '';
          this.removeAttribute('aria-busy');
        }
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
